import ApiService from "./api.service";
export default class TherapistService extends ApiService {
    static base_url = `${super.base_url}/therapists`;
}
